import { render, staticRenderFns } from "./codes-edit-tab.vue?vue&type=template&id=5f7096ea&scoped=true"
import script from "./codes-edit-tab.vue?vue&type=script&lang=js"
export * from "./codes-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./codes-edit-tab.vue?vue&type=style&index=0&id=5f7096ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7096ea",
  null
  
)

export default component.exports